export default __webpack_public_path__ + "static/media/Utric's Keen Knife.de579e3f.jpg";